<div class="modal-container">
  <div class="modal-header">
    <h2>{{ 'ADD_NOTE' | translate}}</h2>
    <button class="btn-close" (click)="onCancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal-body">
    <div class="textarea-wrapper">
      <textarea
        [(ngModel)]="noteText"
        class="note-textarea"
        rows="4"
        [maxlength]="maxLength"
      ></textarea>
      <span class="char-counter" [class.warning]="remainingChars < 100">
        {{ charCount }}/{{ maxLength }}
      </span>
    </div>
    <!-- <p class="helper-text">
      To comment on a draft order or mention a staff member, use Timeline instead
    </p> -->
  </div>

  <div class="modal-footer">
    <button class="btn btn-outline" (click)="onCancel()">{{ 'CANCEL' | translate}}</button>
    <button class="btn btn-primary" (click)="onDone()" [disabled]="!noteText.trim()">
      {{ 'SAVE' | translate}}
    </button>
  </div>
</div>